/* Cart AJAX carries ?_fd=0 on purpose.

   A store served on its .myshopify.com address forwards requests to the
   primary domain. A POST to /cart/add.js lands in the .myshopify.com cart,
   but the follow-up GET /cart.js is forwarded to the primary domain, which
   keeps a different cart — so the drawer reads an empty cart while the
   customer's items sit in the other one. _fd=0 disables that forwarding, so
   every cart call stays on whichever domain the page was served from. It has
   no effect on the primary domain. */
document.addEventListener('DOMContentLoaded', function () {
  /* ---------------------------------------------------------------
   * Product customizer
   *
   * Pricing model: the book, each service tier, and each add-on are
   * SEPARATE Shopify products. Nothing here is a variant of anything
   * else. Every price and variant id is rendered from Shopify by
   * Liquid, so the page can never disagree with checkout.
   * ------------------------------------------------------------- */
  const form = document.getElementById('lahazati-customizer-form');
  if (!form) return;

  let config = { moneyFormat: '${{amount}}', baseVariantId: null, baseCents: 0, waDigits: '96181272350' };
  const configEl = document.getElementById('lahazati-config');
  if (configEl) {
    try {
      config = Object.assign(config, JSON.parse(configEl.textContent));
    } catch (e) {
      console.warn('[Lahazati] config parse error:', e);
    }
  }

  const tierCards = document.querySelectorAll('.tier-card');
  const displayPrice = document.getElementById('display-price');
  const displayCompare = document.getElementById('display-compare');
  const displaySave = document.getElementById('display-save');
  const whatsappBtn = document.getElementById('whatsapp-order-btn');
  const addToCartBtn = document.getElementById('add-to-cart-btn');
  const atcLabel = document.querySelector('[data-atc-label]');
  const atcPrice = document.querySelector('[data-atc-price]');
  const variantIdInput = document.getElementById('selected-variant-id');

  const stickyBar = document.getElementById('StickyATC');
  const stickyTier = document.getElementById('StickyATCTier');
  const stickyPrice = document.getElementById('StickyATCPrice');
  const stickyCompare = document.getElementById('StickyATCCompare');
  const stickyBtn = document.getElementById('StickyATCBtn');


  let activeCard = document.querySelector('.tier-card.active') || tierCards[0];

  /* --- Money ---------------------------------------------------- */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';
    const number = (cents / 100.0).toFixed(precision);
    const parts = number.split('.');
    const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    const format = config.moneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    let value;
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ','); break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return format.replace(placeholder, value);
  }

  /* --- Reading the active tier ---------------------------------- */
  function tierName() {
    return activeCard ? (activeCard.dataset.tier || 'Do It Yourself') : 'Do It Yourself';
  }

  function tierCents() {
    return activeCard ? (Number(activeCard.dataset.priceCents) || 0) : 0;
  }

  function tierCompareCents() {
    return activeCard ? (Number(activeCard.dataset.compareCents) || 0) : 0;
  }

  // The tier IS the variant now — selecting a card changes which variant of
  // the book goes in the cart, rather than adding a second line item.
  function tierVariantId() {
    return activeCard ? (activeCard.dataset.variantId || null) : null;
  }


  /* --- Pricing -------------------------------------------------- */
  function updatePricing() {
    const variantPrice = tierCents();
    const compare = tierCompareCents();

    if (displayPrice) displayPrice.textContent = money(variantPrice);
    // The gift box and add-ons are their own cart lines, so the button used
    // to price the book alone — ticking gift wrapping appeared to add nothing.
    if (atcPrice) atcPrice.innerHTML = '&nbsp;&bull;&nbsp;' + money(variantPrice * quantity() + extrasCents());

    const onSale = compare > variantPrice;
    if (displayCompare) {
      displayCompare.hidden = !onSale;
      displayCompare.textContent = onSale ? money(compare) : '';
    }
    if (displaySave) {
      displaySave.hidden = !onSale;
      if (onSale) {
        displaySave.textContent = 'Save ' + Math.round(((compare - variantPrice) / compare) * 100) + '%';
      }
    }

    // Keep the hidden form input in step, so a non-JS submit still works.
    if (variantIdInput && tierVariantId()) variantIdInput.value = tierVariantId();

    // Mobile quick-buy bar mirrors the same numbers.
    if (stickyTier) stickyTier.textContent = tierName();
    if (stickyPrice) stickyPrice.textContent = money(variantPrice);
    if (stickyCompare) stickyCompare.textContent = onSale ? money(compare) : '';

    if (whatsappBtn) {
      const msg = 'Hello Lahazati, I want to order the Lahazati Video Book — ' +
        tierName() + ' (' + money(variantPrice) + ')';
      whatsappBtn.href = 'https://wa.me/' + config.waDigits + '?text=' + encodeURIComponent(msg);
    }
  }

  /* --- Tier selection ------------------------------------------- */
  function fieldsIn(card) {
    return card ? card.querySelectorAll('.tier-inputs [data-prop-name]') : [];
  }

  // DIY only reveals its upload panel when the customer says they already
  // have a finished video.
  document.querySelectorAll('[data-diy-preload]').forEach(function (cb) {
    const panel = document.querySelector('[data-diy-preload-panel]');
    if (!panel) return;
    cb.addEventListener('change', function () {
      panel.hidden = !this.checked;
      if (!this.checked) {
        panel.querySelectorAll('[data-prop-name]').forEach(function (i) {
          if (i.type !== 'hidden') i.value = '';
        });
      }
    });
  });

  function selectTier(card) {
    tierCards.forEach(function (c) {
      c.classList.remove('active');
      // Disabled fields are not collected, so inactive tiers can't leak values.
      fieldsIn(c).forEach(function (inp) { inp.disabled = true; });
    });

    card.classList.add('active');
    activeCard = card;

    fieldsIn(card).forEach(function (inp) {
      inp.disabled = false;
      inp.classList.remove('lz-input--invalid');
    });

    if (card.classList.contains('nf-wizard') || card.querySelector('.nf-wizard')) {
      resetWizard(card);
    }

    updateTierSummary(card);
    updatePricing();
  }

  /* --- Tier details dialog -------------------------------------- */
  function fieldsHaveValue(card) {
    let filled = 0, total = 0;
    fieldsIn(card).forEach(function (inp) {
      if (inp.type === 'hidden') return;
      total++;
      if (inp.value && inp.value.trim()) filled++;
    });
    return { filled: filled, total: total };
  }

  function updateTierSummary(card) {
    const el = card.querySelector('[data-tier-summary]');
    if (!el) return;
    const n = fieldsHaveValue(card);
    if (n.filled === 0) {
      el.textContent = 'Add your details';
      el.classList.remove('is-filled');
    } else {
      el.textContent = n.filled + ' of ' + n.total + ' details added';
      el.classList.add('is-filled');
    }
  }

  let openTierModal = null;

  function closeTierModal() {
    if (!openTierModal) return;
    const modal = openTierModal;
    openTierModal = null;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 280);
    const card = modal.closest('.tier-card');
    if (card) updateTierSummary(card);
  }

  function openTierModalFor(card) {
    const modal = card.querySelector('[data-tier-modal]');
    if (!modal) return;
    if (openTierModal && openTierModal !== modal) closeTierModal();
    modal.hidden = false;
    // Reflow rather than rAF — a throttled frame loop would leave the
    // panel parked off-screen with the dialog technically open.
    void modal.offsetWidth;
    modal.classList.add('is-open');
    openTierModal = modal;
    document.body.style.overflow = 'hidden';
    const first = modal.querySelector('input:not([type=hidden]), textarea, button');
    if (first) first.focus({ preventScroll: true });
  }

  document.querySelectorAll('[data-tier-edit]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const card = btn.closest('.tier-card');
      if (card !== activeCard) selectTier(card);
      openTierModalFor(card);
    });
  });

  document.querySelectorAll('[data-tier-close], [data-tier-done]').forEach(function (el) {
    el.addEventListener('click', function (e) { e.stopPropagation(); closeTierModal(); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openTierModal) closeTierModal();
  });

  // Keep the card summary honest as they type.
  document.querySelectorAll('[data-tier-modal] [data-prop-name]').forEach(function (inp) {
    inp.addEventListener('input', function () {
      const card = inp.closest('.tier-card');
      if (card) updateTierSummary(card);
    });
  });

  tierCards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('.tier-modal') || e.target.closest('[data-tier-edit]')) return;
      const wasActive = this === activeCard;
      selectTier(this);
      // Choosing a tier goes straight into its details; re-clicking the
      // one already selected shouldn't reopen the dialog unprompted.
      if (!wasActive && this.querySelector('[data-tier-modal]')) openTierModalFor(this);
    });
  });

  /* --- Netflix wizard ------------------------------------------- */
  function wizardOf(card) {
    return card ? card.querySelector('.nf-wizard') : null;
  }

  function showStep(wizard, step) {
    const steps = wizard.querySelectorAll('.nf-step');
    const total = steps.length;
    steps.forEach(function (s) {
      s.style.display = Number(s.dataset.step) === step ? 'flex' : 'none';
    });

    const current = wizard.querySelector('.nf-current');
    if (current) current.textContent = step;

    const fill = wizard.querySelector('.nf-bar-fill');
    if (fill) fill.style.width = ((step / total) * 100) + '%';

    const back = wizard.querySelector('.nf-back');
    const next = wizard.querySelector('.nf-next');
    if (back) back.disabled = step === 1;
    if (next) next.textContent = step === total ? 'Done' : 'Next →';

    wizard.dataset.currentStep = step;
  }

  function resetWizard(card) {
    const wizard = wizardOf(card);
    if (wizard) showStep(wizard, 1);
  }

  // Highlights what's still missing, but never blocks progress: the customer
  // is always allowed to move on and send details later.
  function markStep(wizard, step) {
    const stepEl = wizard.querySelector('.nf-step[data-step="' + step + '"]');
    if (!stepEl) return;
    stepEl.querySelectorAll('[data-guide="true"]').forEach(function (inp) {
      const val = inp.value.trim();
      let bad = !val;
      if (!bad && inp.dataset.validate === 'url') {
        bad = !/^https?:\/\/\S+\.\S+/i.test(val);
      }
      inp.classList.toggle('lz-input--invalid', bad);
    });
  }

  document.querySelectorAll('.nf-wizard').forEach(function (wizard) {
    const total = wizard.querySelectorAll('.nf-step').length;

    const next = wizard.querySelector('.nf-next');
    const back = wizard.querySelector('.nf-back');

    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const step = Number(wizard.dataset.currentStep) || 1;
        markStep(wizard, step);
        if (step < total) showStep(wizard, step + 1);
      });
    }

    if (back) {
      back.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const step = Number(wizard.dataset.currentStep) || 1;
        if (step > 1) showStep(wizard, step - 1);
      });
    }

    showStep(wizard, 1);
  });

  /* --- Extras already ticked (gift box, add-ons) ------------------- */
  function extrasCents() {
    let total = 0;
    document.querySelectorAll('[data-addon-card].is-added').forEach(function (card) {
      const each = parseInt(card.dataset.addonCents, 10) || 0;
      total += each * (parseInt(card.dataset.qty, 10) || 1);
    });
    return total;
  }

  /* --- Quantity --------------------------------------------------- */
  const qtyInput = document.querySelector('[data-qty-input]');

  function quantity() {
    const n = parseInt(qtyInput && qtyInput.value, 10);
    if (!n || n < 1) return 1;
    return Math.min(99, n);
  }

  (function () {
    if (!qtyInput) return;
    const step = (by) => {
      qtyInput.value = String(Math.min(99, Math.max(1, quantity() + by)));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    };
    document.querySelector('[data-qty-down]')?.addEventListener('click', () => step(-1));
    document.querySelector('[data-qty-up]')?.addEventListener('click', () => step(1));
    // Typing "0" or "abc" must not silently add nothing to the cart.
    qtyInput.addEventListener('change', () => {
      qtyInput.value = String(quantity());
      updatePricing();
    });
  })();

  /* --- Line item properties ------------------------------------- */
  function collectProperties() {
    const properties = { 'Service Tier': tierName() };
    // :not([disabled]) means only the active tier's fields are picked up.
    form.querySelectorAll('.tier-inputs [data-prop-name]:not([disabled])').forEach(function (inp) {
      const val = (inp.value || '').trim();
      if (val) properties[inp.dataset.propName] = val;
    });
    return properties;
  }

  // Deliberately never returns false. Missing details are collected after the
  // order via WhatsApp — an empty field must not cost a sale.
  function markMissing() {
    fieldsIn(activeCard).forEach(function (inp) {
      if (inp.dataset.guide !== 'true') return;
      inp.classList.toggle('lz-input--invalid', !inp.value.trim());
    });
  }

  /* --- Add to cart ---------------------------------------------- */
  /* --- Add-ons: tap to add straight to the cart -------------------
     Deliberately not bundled into the main button. Each card is its own
     one-tap add, and tapping again removes it, so the card always
     reflects what is actually in the cart.
     ---------------------------------------------------------------- */
  const addonCards = document.querySelectorAll('[data-addon-card]');

  function paintCard(card, qty) {
    const added = qty > 0;
    const btn = card.querySelector('[data-addon-add]');
    card.dataset.qty = String(added ? qty : 0);
    card.classList.toggle('is-added', added);

    // Stickers are bought in twos and threes, so the row keeps a stepper
    // once it is in the cart. Gift wrapping has no stepper — one is one.
    const qtyBox = card.querySelector('[data-addon-qty]');
    if (qtyBox) {
      qtyBox.hidden = !added;
      const countEl = card.querySelector('[data-addon-count]');
      if (countEl) countEl.textContent = String(added ? qty : 1);
      const down = card.querySelector('[data-addon-down]');
      if (down) down.setAttribute('aria-label', qty > 1 ? 'One less' : 'Remove');
    }
    // Icon-only button: never write text into it, or the SVG is destroyed.
    if (btn) {
      btn.setAttribute('aria-label',
        (added ? 'Remove ' : 'Add ') + (card.dataset.addonName || 'add-on') +
        (added ? ' from cart' : ' to cart'));
      btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    }
    // Gift wrapping uses a tick rather than a button, but is the same line.
    const toggle = card.querySelector('[data-gift-toggle]');
    if (toggle) toggle.checked = added;
    const confirm = card.querySelector('[data-gift-confirm]');
    if (confirm) confirm.hidden = !added;
    updatePricing();
  }

  function refreshCartUi(cart) {
    document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count === 0 ? 'none' : 'flex';
    });
    if (window.LahazatiCart && typeof window.LahazatiCart.refresh === 'function') {
      window.LahazatiCart.refresh();
    }
  }

  // Reflect whatever is already in the cart when the page loads.
  function syncAddonsFromCart() {
    if (!addonCards.length) return Promise.resolve();
    return fetch('/cart.js?_fd=0')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const counts = {};
        cart.items.forEach(function (i) {
          counts[String(i.variant_id)] = (counts[String(i.variant_id)] || 0) + i.quantity;
        });
        addonCards.forEach(function (card) {
          paintCard(card, counts[String(card.dataset.addonVariantId)] || 0);
        });
      })
      .catch(function () { /* leave the cards as they are */ });
  }

  // One code path for every optional extra. An add-on row drives it with a
  // button, gift wrapping with a tick box, but both are their own cart line
  // and both must reflect the cart rather than the control that was clicked.
  async function setAddonQty(card, want) {
    const id = parseInt(card.dataset.addonVariantId, 10);
    if (!id) return;

    const qty = Math.max(0, Math.min(99, want));
    const before = parseInt(card.dataset.qty, 10) || 0;
    if (qty === before) return;

    const btn = card.querySelector('[data-addon-add]');
    const toggle = card.querySelector('[data-gift-toggle]');
    const steps = card.querySelectorAll('[data-addon-up], [data-addon-down]');
    card.classList.add('is-busy');
    if (btn) btn.disabled = true;
    if (toggle) toggle.disabled = true;
    steps.forEach(function (b) { b.disabled = true; });

    // Paint first: a stepper that waits for the network feels broken.
    paintCard(card, qty);

    try {
      if (before === 0) {
        const res = await fetch('/cart/add.js?_fd=0', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        });
        if (!res.ok) throw new Error('add failed');
      } else {
        // change.js works on a line that exists; quantity 0 removes it.
        const res = await fetch('/cart/change.js?_fd=0', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: qty })
        });
        if (!res.ok) throw new Error('change failed');
      }
    } catch (err) {
      console.error('[Lahazati] extra', err);
      card.classList.add('is-error');
      setTimeout(function () { card.classList.remove('is-error'); }, 1800);
      // Put the control back: a tick left on after a failed add would promise
      // wrapping that is not in the cart.
      paintCard(card, before);
    } finally {
      card.classList.remove('is-busy');
      if (btn) btn.disabled = false;
      if (toggle) toggle.disabled = false;
      steps.forEach(function (b) { b.disabled = false; });
    }

    // Reading the cart is presentation only. A failure here must not be
    // reported as a failed add.
    try {
      const cart = await fetch('/cart.js?_fd=0').then(function (r) { return r.json(); });
      refreshCartUi(cart);
    } catch (err) {
      console.warn('[Lahazati] cart read', err);
    }
  }

  addonCards.forEach(function (card) {
    card.dataset.qty = card.dataset.qty || '0';

    const btn = card.querySelector('[data-addon-add]');
    if (btn) {
      btn.addEventListener('click', function () {
        setAddonQty(card, (parseInt(card.dataset.qty, 10) || 0) > 0 ? 0 : 1);
      });
    }

    const up = card.querySelector('[data-addon-up]');
    if (up) {
      up.addEventListener('click', function () {
        setAddonQty(card, (parseInt(card.dataset.qty, 10) || 0) + 1);
      });
    }

    const down = card.querySelector('[data-addon-down]');
    if (down) {
      down.addEventListener('click', function () {
        setAddonQty(card, (parseInt(card.dataset.qty, 10) || 0) - 1);
      });
    }

    const toggle = card.querySelector('[data-gift-toggle]');
    if (toggle) {
      toggle.addEventListener('change', function () {
        setAddonQty(card, toggle.checked ? 1 : 0);
      });
    }
  });

  syncAddonsFromCart();

  /* --- Add-on carousel ------------------------------------------- */
  (function () {
    const track = document.querySelector('[data-addon-track]');
    const prev = document.querySelector('[data-addon-prev]');
    const next = document.querySelector('[data-addon-next]');
    if (!track || !prev || !next) return;

    function step() {
      const card = track.querySelector('.lz-addon-card');
      // Scroll by whole cards so nothing is ever left half-visible.
      return card ? (card.getBoundingClientRect().width + 10) * 2 : 260;
    }

    function syncArrows() {
      const max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
      // No point showing controls when everything already fits.
      const nav = prev.parentElement;
      if (nav) nav.style.display = track.scrollWidth > track.clientWidth + 2 ? 'flex' : 'none';
    }

    // Re-sync after the click rather than relying only on the scroll event,
    // so the disabled states stay correct even if that event is throttled.
    function go(direction) {
      track.scrollBy({ left: direction * step(), behavior: 'smooth' });
      setTimeout(syncArrows, 400);
      setTimeout(syncArrows, 1000);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', syncArrows, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', syncArrows);
    window.addEventListener('resize', syncArrows, { passive: true });
    syncArrows();
  })();

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (!addToCartBtn || addToCartBtn.disabled) return;

    const bookVariantId = tierVariantId() || (variantIdInput ? variantIdInput.value : null);
    if (!bookVariantId) {
      console.error('[Lahazati] No variant selected — cannot add to cart.');
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      return;
    }

    markMissing();

    const labelEl = atcLabel || addToCartBtn;
    const originalText = labelEl.textContent;
    addToCartBtn.disabled = true;
    labelEl.textContent = 'Adding...';
    if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = 'Adding...'; }

    const restoreSticky = function () {
      if (stickyBtn) { stickyBtn.disabled = false; stickyBtn.textContent = 'Add to Cart'; }
    };

    const fail = function (label) {
      labelEl.textContent = label || 'Error — Try Again';
      setTimeout(function () { labelEl.textContent = originalText; }, 2200);
      addToCartBtn.disabled = false;
      restoreSticky();
    };

    // Add-ons are added to the cart on their own tap, so this is just the
    // book at whichever tier variant is selected.
    const items = [{
      id: parseInt(bookVariantId, 10),
      quantity: quantity(),
      properties: collectProperties()
    }];

    try {
      const response = await fetch('/cart/add.js?_fd=0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        const error = await response.json().catch(function () { return null; });
        console.error('[Lahazati] Cart add error:', error);
        fail(error && error.description ? 'Unavailable' : 'Error — Try Again');
        return;
      }

      // The line is in the cart from here on. Reading the cart back can still
      // fail on the .myshopify.com preview domain, where /cart.js redirects to
      // the primary domain and CORS blocks it — that must not be reported as a
      // failed add, or the customer adds everything a second time.
      try {
        const cartData = await fetch('/cart.js?_fd=0').then(function (r) { return r.json(); });
        document.querySelectorAll('[data-cart-count], .cart-count').forEach(function (el) {
          el.textContent = cartData.item_count;
          el.style.display = cartData.item_count === 0 ? 'none' : 'flex';
        });
      } catch (err) {
        console.warn('[Lahazati] could not refresh the cart count', err);
      }

      labelEl.textContent = originalText;
      addToCartBtn.disabled = false;
      restoreSticky();

      if (window.LahazatiCart && typeof window.LahazatiCart.open === 'function') {
        window.LahazatiCart.open();
        if (typeof window.LahazatiCart.refresh === 'function') window.LahazatiCart.refresh();
      } else {
        const drawer = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
        const overlay = document.getElementById('CartOverlay');
        if (drawer) {
          drawer.classList.add('is-open');
          if (overlay) {
            overlay.classList.add('is-visible');
            overlay.setAttribute('aria-hidden', 'false');
          }
          document.body.style.overflow = 'hidden';
        } else {
          window.location.href = '/cart';
        }
      }
    } catch (err) {
      console.error('[Lahazati]', err);
      fail();
    }
  });

  /* --- Mobile sticky quick-buy ----------------------------------- */
  if (stickyBar && stickyBtn && addToCartBtn) {
    // Hand the click to the real form so validation and line-item
    // properties behave exactly the same as the in-page button.
    stickyBtn.addEventListener('click', function () {
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    });

    // Show the bar once the real button has scrolled out of view. A plain
    // scroll listener rather than IntersectionObserver: the bar must also
    // react to the page growing/shrinking as tier panels open and close,
    // which a single observed rect does not capture.
    let ticking = false;
    const syncStickyBar = function () {
      const r = addToCartBtn.getBoundingClientRect();
      // Only once they've actually engaged with the page — showing a buy bar
      // before the shopper has seen the product reads as pushy.
      const engaged = window.scrollY > 500;
      const offScreen = r.bottom < 0 || r.top > window.innerHeight;
      stickyBar.classList.toggle('is-visible', engaged && offScreen);
      ticking = false;
    };
    const onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncStickyBar);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    syncStickyBar();
  }

  /* --- Boot ------------------------------------------------------ */
  if (activeCard) selectTier(activeCard);
  updatePricing();
});
